import {APP_INITIALIZER, NgModule, Optional, SkipSelf} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {AuthInterceptor} from '@core/interceptors/auth.interceptor';

import {NgxTranslationsModule} from '@ngx-translations/translations.module';
import {NgxNotificationsModule} from '@ngx-notifications/notifications.module';
import {PlatformsService} from '@core/services/platforms.service';

import {environment} from '@env/environment';
import {dutch} from '@internationalization/languages';
import {BbElementsModule} from '@bravobit/bb-foundation';

@NgModule({
    imports: [
        // Angular modules.
        BrowserAnimationsModule,
        HttpClientModule,
        // Custom library modules.
        BbElementsModule.forRoot(),
        NgxNotificationsModule.forRoot(),
        NgxTranslationsModule.forRoot({
            production: environment.production,
            dictionary: [
                {languages: ['nl-NL', 'nl'], locale: 'nl-NL', data: dutch, name: 'Dutch (Dutch)'}
            ]
        })
    ]
})
export class CoreModule {

    constructor(@Optional() @SkipSelf() parent: CoreModule) {
        if (parent) {
            throw new Error('CoreModule is already loaded; Import it in the AppModule only.');
        }
    }

    static forRoot() {
        return {
            ngModule: CoreModule,
            providers: [
                {provide: APP_INITIALIZER, deps: [PlatformsService], useFactory: initializePlatform, multi: true},
                {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true}
            ]
        };
    }

}

export function initializePlatform(platforms: PlatformsService) {
    return platforms.initialize();
}
